import { Components } from "@thisgorilla/primate-ds";
import { useEffect } from "react";

import { API_CALLS } from "../../../../../API/api_calls";
import { useAppSelector } from "../../../../../redux";
import { FlexColumn } from "../../../../Common/Styles";
import CardLayout from "./CardLayout";

export const SavedItems = () => {
  const { getSavedItemsCountsAPI_STATUS, jobs, posts, articles } =
    useAppSelector((state) => state.savedItems);

  useEffect(() => {
    if (getSavedItemsCountsAPI_STATUS !== "idle") return;
    API_CALLS.SAVED_ITEMS.getSavedItemsCounts();
  }, [getSavedItemsCountsAPI_STATUS]);

  return (
    <CardLayout title="Saved Items">
      <FlexColumn $gapInPx={8}>
        <Components.ListItem
          label="Jobs"
          type="List Item"
          onClick={() => {}}
          iconType="Briefcase"
          count={String(jobs)}
          countColor="Light"
        />
        <Components.ListItem
          label="Posts"
          type="List Item"
          onClick={() => {}}
          iconType="Layout"
          count={String(posts)}
          countColor="Light"
        />
        <Components.ListItem
          label="Articles"
          type="List Item"
          onClick={() => {}}
          iconType="FileText"
          count={String(articles)}
          countColor="Light"
        />
      </FlexColumn>
    </CardLayout>
  );
};
